import React from 'react'
import {
  Card,
  SocialMediaSection,
  InfoSection,
  HausMartName,
  HausMartDescription,
  SocialIcon
} from './AboutHausmartStyledComponents'
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaPinterestP } from 'react-icons/fa'
import PropTypes from 'prop-types'
import Parser from 'html-react-parser'

const chooseIcon = iconName => {
  switch (iconName) {
    case 'facebook':
      return <FaFacebookF />
    case 'instagram':
      return <FaInstagram />
    case 'twitter':
      return <FaTwitter />
    case 'linkedin':
      return <FaLinkedinIn />
    case 'pinterest':
      return <FaPinterestP />
    default:
  }
}

const generateIcons = socialMedia => {
  return socialMedia.map(social => (
    <div key={social.type}>
      <SocialIcon href={social.url} target="_blank">
        {chooseIcon(social.type)}
      </SocialIcon>
      <p>{social.name}</p>
    </div>
  ))
}

const AboutHausmart = React.memo(({ name, description, socialMedia }) => {
  return (
    <Card>
      <InfoSection>
        <HausMartName>{name}</HausMartName>
        <HausMartDescription>{Parser(description)}</HausMartDescription>
      </InfoSection>
      <SocialMediaSection
        height={`calc(3em + ${(socialMedia && socialMedia.length ? socialMedia.length : 0) * 32}px + 2em)`}
      >
        {generateIcons(socialMedia)}
      </SocialMediaSection>
    </Card>
  )
})

AboutHausmart.displayName = 'AboutHausmart'

AboutHausmart.defaultProps = {
  name: '',
  description: '',
  socialMedia: []
}

AboutHausmart.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  socialMedia: PropTypes.array
}

export default AboutHausmart
